/*eslint-disable*/
import React, { useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';

import EditModal from '.././bill/modals/editModal';
import BillPaymentDetailsModal from '.././bill/modals/billPaymentDetailsModal';


function PaymentActionButton(props) {

  const billData = props.data

  const [openModal, setOpenModal] = useState(false)


  const handlePayments = (e) => {
    setOpenModal(true)
  }

  const handleClosePayments = () => {
    setOpenModal(false)
  }

  return (
    <>
      {billData.vendorBillNo} <Button onClick={handlePayments} basic className="w3-tiny" circular type="button" icon> <Icon name="info" color="grey" size='small' /></Button>
      <EditModal size="small" open={openModal} onClose={handleClosePayments}>
        <BillPaymentDetailsModal billData={billData} />
      </EditModal>

    </>
  )
}

export default PaymentActionButton
